/**
 * Story content is user-authored Slate JSON, so a link's URL is untrusted. Only
 * web and mail links are rendered as-is; anything else (`javascript:`, `data:`,
 * `vbscript:`, …) would run in the reader's session, and is replaced by an
 * inert href.
 */
const SAFE_LINK_PROTOCOLS = new Set(['http:', 'https:', 'mailto:'])

export function safeLinkHref(url: unknown): string {
  if (typeof url !== 'string') return '#'
  const trimmed = url.trim()
  if (!trimmed) return '#'
  // Same-site paths and fragments carry no scheme at all
  if (/^(\/(?!\/)|#|\?)/.test(trimmed)) return trimmed
  try {
    // The URL parser normalises the tricks ("JaVaScRiPt:", embedded tabs/newlines)
    return SAFE_LINK_PROTOCOLS.has(new URL(trimmed).protocol) ? trimmed : '#'
  } catch {
    return '#' // not an absolute URL we can vouch for
  }
}

/** Only web images — a branch's content must not make the page load arbitrary schemes. */
export function safeImageSrc(url: unknown): string | undefined {
  if (typeof url !== 'string') return undefined
  try {
    const protocol = new URL(url.trim()).protocol
    return protocol === 'https:' || protocol === 'http:' ? url.trim() : undefined
  } catch {
    return undefined
  }
}
